import {
  get,
  post,
  postWithFiles,
  patchWithFiles,
  del,
} from "./fetch-portal-api";
import fakeDataAll from "./fakes/all.fake";
import { ActivityType } from "../Helpers/types";

const postLogin = (
  data: any,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  post("/accounts/login", data, success, error);
};

const postRefreshToken = (
  refreshToken: any,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  post(
    "/accounts/refreshtoken",
    { refreshToken: refreshToken },
    success,
    error
  );
};

const postLogout = (
  refreshToken: any,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  post("/accounts/logout", { refreshToken: refreshToken }, success, error);
};

const getAll = (success: (data: any) => void, error: (err: any) => void) => {
  get(
    `/dealpipelines/leads/all?vendors=${getVendorsParameter()}`,
    success,
    error,
    fakeDataAll
  );
};

const getActiveLeads = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(
    `/dealpipelines/leads/active?vendors=${getVendorsParameter()}`,
    success,
    error,
    fakeDataAll
  );
};

const getStalledLeads = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(
    `/dealpipelines/leads/stalled?vendors=${getVendorsParameter()}`,
    success,
    error,
    fakeDataAll
  );
};

const getActiveTransactions = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(
    `/dealpipelines/transactions/active?vendors=${getVendorsParameter()}`,
    success,
    error,
    fakeDataAll
  );
};

const getStalledTransactions = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(
    `/dealpipelines/transactions/stalled?vendors=${getVendorsParameter()}`,
    success,
    error,
    fakeDataAll
  );
};

const getFundedTransactions = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(
    `/dealpipelines/transactions/funded?vendors=${getVendorsParameter()}`,
    success,
    error,
    fakeDataAll
  );
};

const getUsers = (success: (data: any) => void, error: (err: any) => void) => {
  get("/accounts", success, error);
};

const postAddUser = (
  data: any,
  file: any,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  postWithFiles("/accounts", data, { companyLogoFile: file }, success, error);
};

const patchUpdateUser = (
  data: any,
  file: any,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  patchWithFiles("/accounts", data, { companyLogoFile: file }, success, error);
};

const postResetPassword = (
  data: any,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  post("/accounts/resetpassword", data, success, error);
};

const postForgotPassword = (
  emailAddress: string,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  post("/accounts/forgotpassword", { emailAddress }, success, error);
};

const getChatHash = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get("/accounts/chathash", success, error);
};

const getVendors = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get("/vendors", success, error);
};

const getCompanyAndTaycorRep = (
  activityId: string,
  activityType: ActivityType,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(`/${activityType}s/${activityId}/companyandrep`, success, error);
};

const getMilestones = (
  activityId: string,
  activityType: ActivityType,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(`/${activityType}s/${activityId}/milestones`, success, error);
};

const getMyPipeline = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(`/dashboards/mypipeline`, success, error);
};

const getActiveInventory = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(
    `/inventorytracker/active?vendors=${getVendorsParameter()}`,
    success,
    error,
    fakeDataAll
  );
};

const getSoldInventory = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(
    `/inventorytracker/sold?vendors=${getVendorsParameter()}`,
    success,
    error,
    fakeDataAll
  );
};

const getAllInventory = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(
    `/inventorytracker/all?vendors=${getVendorsParameter()}`,
    success,
    error,
    fakeDataAll
  );
};

const getInventoryItemDetails = (
  itemId: string,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(`/inventorytracker/${itemId}/details`, success, error);
};

const getMyInventory = (
  success: (data: any) => void,
  error: (err: any) => void
) => {
  get(`/dashboards/myinventory`, success, error);
};

const postCreateUploadInstance = (
  itemId: string,
  itemType: "lead" | "transaction",
  success: (data: any) => void,
  error: (err: any) => void
) => {
  post(`/uploads/${itemType}/${itemId}`, {}, success, error);
};

const deleteUploadInstance = (
  itemId: string,
  itemType: "lead" | "transaction",
  success: (data: any) => void,
  error: (err: any) => void
) => {
  del(`/uploads/${itemType}/${itemId}`, success, error);
};

const postSetupApiAccess = (
  userId: string,
  success: (data: any) => void,
  error: (err: any) => void
) => {
  post(`/accounts/${userId}/apiaccess`, {}, success, error);
};

const getVendorsParameter = () =>
  encodeURIComponent(
    JSON.parse(sessionStorage.getItem("vendors") || "[]").join(",")
  ).substr(0, 1500);

export {
  postLogin,
  postRefreshToken,
  postLogout,
  getAll,
  getActiveLeads,
  getStalledLeads,
  getActiveTransactions,
  getStalledTransactions,
  getFundedTransactions,
  getUsers,
  postAddUser,
  patchUpdateUser,
  postResetPassword,
  postForgotPassword,
  getChatHash,
  getVendors,
  getCompanyAndTaycorRep,
  getMilestones,
  getMyPipeline,
  getActiveInventory,
  getSoldInventory,
  getInventoryItemDetails,
  getMyInventory,
  getAllInventory,
  postCreateUploadInstance,
  deleteUploadInstance,
  postSetupApiAccess,
};
